import { format, isValid, parse } from 'date-fns';

import type { BranchDetail } from '@/features/local-configuration/types/local-configuration-api.types';

const DISPLAY_FORMAT = 'dd/MM/yyyy';
const ISO_DAY_FORMAT = 'yyyy-MM-dd';

/** Normalize API date strings to calendar day `yyyy-MM-dd`. */
function toIsoDay(value: string | undefined | null): string {
  const trimmed = value?.trim() ?? '';
  if (!trimmed) {
    return '';
  }

  const isoMatch = trimmed.match(/^(\d{4}-\d{2}-\d{2})/);
  if (isoMatch?.[1]) {
    return isoMatch[1];
  }

  const fromDisplay = parse(trimmed, DISPLAY_FORMAT, new Date());
  if (isValid(fromDisplay)) {
    return format(fromDisplay, ISO_DAY_FORMAT);
  }

  const fromNative = new Date(trimmed);
  if (isValid(fromNative)) {
    return format(fromNative, ISO_DAY_FORMAT);
  }

  return '';
}

/**
 * True when the active branch subscription day is strictly before today.
 * Fail-open: missing/invalid expireDate or stale branchDetail ⇒ not expired.
 */
export function isBranchSubscriptionExpired(
  branchDetail: BranchDetail | null | undefined,
  activeBranchCode: string | null | undefined,
): boolean {
  if (!branchDetail || !activeBranchCode) {
    return false;
  }

  if (branchDetail.branchCode !== activeBranchCode) {
    return false;
  }

  const expireDay = toIsoDay(branchDetail.expireDate);
  if (!expireDay) {
    return false;
  }

  const today = format(new Date(), ISO_DAY_FORMAT);
  return expireDay < today;
}
